






















import { defineComponent } from '@vue/composition-api';
import cButton             from '@/components/form/button/button.component.vue';
import { useGlobals }      from '@/hooks/use-globals';

export default defineComponent({
  name: 'cFooterPanel',
  components: {
    cButton,
  },
  props: {
    showCancelButton: {
      type: Boolean,
      default: false,
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { store, i18n } = useGlobals();

    const emitSave = (): void => {
      context.emit('saveElement');
    };

    const emitCancel = (): void => {
      context.emit('cancelClick');
    };

    const getTranslation = (value: string): string => (i18n.t(`${store.state.i18n.GLOBAL_PATH}.buttons.${value}`)).toString();

    return {
      getTranslation,
      emitSave,
      emitCancel,
    };
  },
});
